var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPeopleGrayGc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPeopleGrayGC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.6363636,5.14285714 C15.1454545,5.14285714 16.3545455,3.99428571 16.3545455,2.57142857 C16.3545455,1.14857143 15.1454545,0 13.6363636,0 C12.1272727,0 10.9090909,1.14857143 10.9090909,2.57142857 C10.9090909,3.99428571 12.1272727,5.14285714 13.6363636,5.14285714 Z M6.36363636,5.14285714 C7.87272727,5.14285714 9.08181818,3.99428571 9.08181818,2.57142857 C9.08181818,1.14857143 7.87272727,0 6.36363636,0 C4.85454545,0 3.63636364,1.14857143 3.63636364,2.57142857 C3.63636364,3.99428571 4.85454545,5.14285714 6.36363636,5.14285714 Z M6.36363636,6.85714286 C4.24545455,6.85714286 0,7.86 0,9.85714286 L0,11.1428571 C0,11.6142857 0.409090909,12 0.909090909,12 L11.8181818,12 C12.3181818,12 12.7272727,11.6142857 12.7272727,11.1428571 L12.7272727,9.85714286 C12.7272727,7.86 8.48181818,6.85714286 6.36363636,6.85714286 Z M13.6363636,6.85714286 C13.3727273,6.85714286 13.0727273,6.87428571 12.7545455,6.9 C12.7727273,6.90857143 12.7818182,6.92571429 12.7909091,6.93428571 C13.8272727,7.64571429 14.5454545,8.59714286 14.5454545,9.85714286 L14.5454545,11.1428571 C14.5454545,11.4428571 14.4818182,11.7342857 14.3818182,12 L19.0909091,12 C19.5909091,12 20,11.6142857 20,11.1428571 L20,9.85714286 C20,7.86 15.7545455,6.85714286 13.6363636,6.85714286 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icPeopleGrayGC",
    fill: "#848890",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPeopleGrayGc);
export default __webpack_public_path__ + "static/media/icPeopleGrayGC.4553535713ddcd66278cc973d19cc782.svg";
export { ForwardRef as ReactComponent };